var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"dashboard",staticClass:"vcp-m-dashboard",attrs:{"autoplay":""}},[_c('MobileControls',{attrs:{"muted":_vm.muted}}),_c('Progress')],1)}
var staticRenderFns = []

export { render, staticRenderFns }